export default __webpack_public_path__ + "static/media/cloud-upload.bd76ef37.svg";